import { IAddToWishlistProps } from '@models/IAddToWishlist';
import { ComponentType, createContext } from 'react';

export const WishlistButtonContext =
  createContext<ComponentType<IAddToWishlistProps> | null>(null);
